export default {
  currentUser: null
};